import * as React from "react";
import PropTypes from "prop-types";

import "./styles.css";
import { _ } from "../../model/utils";

const ConfirmButton = ({ disabled, onClick }) => (
  <div className="row">
    <div className="col-12" styleName="center">
      <button
        type="button"
        styleName="button"
        disabled={disabled}
        onClick={onClick}
      >
        {_.confirmButton}
      </button>
    </div>
  </div>
);

ConfirmButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default ConfirmButton;
